<template>
  <section class="task-detail-page h-full w-full flex flex-col bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <!-- Breadcrumb -->
      <nav class="text-sm text-gray-600 mb-6 flex flex-wrap items-center gap-1">
        <router-link to="/dashboard" class="hover:text-blue-700 transition font-medium">Dashboard</router-link>
        <span>/</span>
        <router-link to="/tasks" class="hover:text-blue-700 transition font-medium">Task Management</router-link>
        <span>/</span>
        <router-link v-if="taskData && taskData.board" :to="`/tasks/board/${taskData.board.id}`" class="hover:text-blue-700 transition font-medium">
          {{ taskData.board.name }}
        </router-link>
        <span v-else class="text-gray-500">Board</span>
        <span>/</span>
        <span class="text-blue-900 font-semibold">{{ taskData ? taskData.title : 'Task' }}</span>
      </nav>

      <!-- Task Detail Content -->
      <div class="bg-white border border-gray-200 rounded-2xl shadow-md overflow-hidden">
        <TaskDetailModal :task-id="taskId" :board-members="[]" />
      </div>
    </div>
  </section>
</template>

<script>
import gql from 'graphql-tag';
import TaskDetailModal from './components/TaskDetailModal.vue';

export default {
  name: 'TaskDetailPage',
  components: {
    TaskDetailModal,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    taskId() {
      return parseInt(this.id, 10) || this.id;
    },
    taskData() {
      if (!this.task || this.task.error) return null;
      return this.task.data;
    },
  },
  apollo: {
    task: {
      query: gql`
        query GetTaskBreadcrumb($id: ID!) {
          task(id: $id) {
            error
            error_code
            message
            data {
              id
              title
              board {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return { id: this.taskId };
      },
      fetchPolicy: 'cache-and-network',
    },
  },
};
</script>
